import { gql, useLazyQuery, useMutation, useQuery } from "@apollo/client";
import React, { useContext, useEffect, useRef, useState } from "react";
import Loader from "react-loader-spinner";
import styled from "styled-components";
import colors from "../constants/colors";
import { GetCurrentPage, GetUserContext } from "../localStorage/Store";
import Error404 from "../pages/error/Error404";
import AccordionComp from "./Accordion/Accordion";
import Alert from "./Alert";
import CircleWithText from "./CircleWithText";
import RefInput from "./RefInput";
import SingleSelect from "./SingleSelect";
import StyledButton from "./StyledButton";
import Brand from "../assets/images/Brand.jpg";

const GetExtCartItems = gql`
  query getExtCartItems($subordererKey: String!) {
    __typename
    extCart(subordererKey: $subordererKey) {
      lists {
        name
        total
        orderers {
          products {
            amount
            rowId
            total
            product {
              parent {
                name
              }
              name
              price
              weight
              variationId
              id
            }
          }
          name
          total
          paid
          paidRowId
        }
      }

      total
      totalWeight
    }
  }
`;

const CheckCouponCode2 = gql`
  query MyQuery($code: String!) {
    __typename
    checkCoupon(code: $code) {
      amount
      type
      valid
    }
  }
`;

const setPriceNameMutation = gql`
  mutation updateCustomer($id: ID, $showName: Boolean, $showPrice: Boolean) {
    __typename
    updateCustomer(
      input: {
        clientMutationId: "UpdateCustomer"
        showName: $showName
        showPrice: $showPrice
        id: $id
      }
    ) {
      customer {
        billing {
          firstName
          address1
          city
          country
          email
          lastName
          phone
          postcode
          state
        }
        shipping {
          address1
          city
          postcode
          state
          country
          firstName
          lastName
          email
          phone
        }
        hasCoupon
        orderCount
        lastName
        firstName
        email
        customerId
        id
        username
        iban
        bank
        showName
        showPrice
      }
    }
  }
`;
/**
 * @author Samuel Plankel
 * @param {function} saveOrder the function which is called when the complete Order button has been fired
 * @param {funciton} activeView the function which is called when the back or complete Order Button has been fired
 * @param {string} subordererKey the key of the order where Suborderer can join and add to cart
 * @param {string} parentPage if the component is called from the MultipleBuyerPage
 * @param {Object} customer the customer if it is not the same as the userData
 * @example <OrderOverview parentPage={'MultipleBuyerPage'} subordererKey={""} saveOrder={() => SaveOrder()} activeView={(pageName) => handleView(pageName)} />
 */

const OrderOverview = ({
  saveOrder,
  activeView,
  subordererKey,
  parentPage,
  customer,
}) => {
  const { loading: loadingExtCart, error, data: content, refetch } = useQuery(
    GetExtCartItems,
    {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: "network-only",
      variables: { subordererKey },
      // onCompleted: (CartItems) => {
      // 		// setSelected([])

      // 	// setTotalCart(CartItems.extCart.total)
      //   setSelected(CartItems.extCart.lists);
      //   // if (parentPage==='DataInputSubbesteller') setter(CartItems.extCart.lists)
      // }
    }
  );
  const [
    setPriceNameMutation2,
    { loading: mutationLoading2, error: mutationError2 },
  ] = useMutation(setPriceNameMutation);


  useEffect(() => {
    if (content && !selected) {
      setSelected(content.extCart.lists);
    }
  }, [content]);
  const [
    checkCouponCodeQuery,
    { loading: loading2, error: error2, data },
  ] = useLazyQuery(CheckCouponCode2);

  const [user, setUser] = useContext(GetUserContext);
  const { selected, setSelected, duration } = useContext(GetCurrentPage);
  const [toggleCoupon, setToggleCoupon] = useState(true);
  const [couponCode, setCouponCode] = useState("");
  const [couponAmount, setCouponAmount] = useState("");
  const [couponType, setCouponType] = useState("");
  const [showCoupon, setShowCoupon] = useState(false);
  const [errorWeight, setErrorWeight] = useState();
  const [showPriceState, setShowPriceState] = useState(user.showPrice);
  const [showNameState, setShowNameState] = useState(user.showName);
  const [showCouponAlert, setShowCouponAlert] = useState(false);
  const [showCouponErrorAlert, setShowCouponErrorAlert] = useState(false);

  //   const [couponAmount, setCouponAmount] = useState();
  //   const [couponType, setCouponType] = useState();

  const couponsRef = useRef();
  const [totalCart, setTotalCart] = useState(0);
  const [reload, setReload] = useState(true);


  useEffect(() => {
    if (user.hasCoupon) {
      setShowCoupon(true)
    } else {
      setShowCoupon(false)
    }
  }, [])

  useEffect(() => {
    if (data) {

      let response = data.checkCoupon;

      if (response.valid) {



        if (response.type === "percent") {
          setCouponType("%");
        } else if (response.type === "fixed_cart") {
          setCouponType("€");
        }
        setCouponAmount(response.amount);
        setToggleCoupon(false);
        setShowCouponAlert(true)

      } else {
        setShowCouponErrorAlert(true)
      }
    }
  }, [data])

  const CheckValidOrder = async () => {


    if (content?.extCart?.totalWeight >= 8) {
      await saveOrder(couponCode);
      activeView("OrderComplete");
    } else {
      setErrorWeight("Die Mindestbestellmenge von 8 kg wurde nicht erreicht")

    }
  };

  const CheckCoupon = () => {
    let coupon = couponsRef.current.value;

    checkCouponCodeQuery({ variables: { code: coupon } });
    setCouponCode(coupon);
  };

  const saveShowNamePrice = (e) => {
    setReload(false);
    let showNameEtikett = false;
    let showPriceEtikett = false;
    if (e == "price") {
      showNameEtikett = user.showName;
      showPriceEtikett = !user.showPrice;
    } else if (e == "name") {
      showNameEtikett = !user.showName;
      showPriceEtikett = user.showPrice;
    }

    setPriceNameMutation2({
      variables: {
        id: user.id,
        showPrice: showPriceEtikett,
        showName: showNameEtikett,
      },
    })
      .then((response) => {
        setUser(response.data.updateCustomer.customer);
        if (showNameEtikett) {
          setShowNameState(true);
        }
        if (showPriceEtikett) {
          setShowPriceState(true);
        }
      })
      .catch((error) => {
        alert(error.toString());
      });
  };

  // if (loading) return "Loading...";
  if (error) return <Error404 />;

  return (
    <Wrapper>
      <Content>
        {parentPage != "SingleBuyerPage" && <CircleWrapper>
          {duration.toString().includes("Bestelldauer") ? <CircleWithText>{duration} </CircleWithText> : <CircleWithText size="170" font="18">
            Bestellmöglichkeit: <br />{duration.toString().includes("Uhr") ? <strong> bis {duration}</strong> : <><strong>noch {duration} Tag(e)</strong> offen</>}
          </CircleWithText>}
        </CircleWrapper>}
        <LoginContainer>
          {customer ? (
            <React.Fragment>
              <ContentContainer>
                <HeadingSmall>Rechnungsadresse</HeadingSmall>
                <DataParagraph>
                  {customer.billing.firstname} {customer.billing.lastname}
                </DataParagraph>
                <DataParagraph>{customer.billing.adress}</DataParagraph>
                <DataParagraph>
                  {customer.billing.postcode} {customer.billing.city}
                </DataParagraph>
                <DataParagraph>{customer.billing.country}</DataParagraph>
                {/* <p>{customer.billing.phone}</p>
                <p>{customer.billing.email}</p> */}
              </ContentContainer>
              <ContentContainer>
                <HeadingSmall>Lieferadresse</HeadingSmall>
                <DataParagraph>
                  {customer.shipping.firstnameshipping}{" "}
                  {customer.shipping.lastnameshipping}
                </DataParagraph>
                <DataParagraph>
                  {customer.shipping.adressshipping}
                </DataParagraph>
                <DataParagraph>
                  {customer.shipping.postcodeshipping}{" "}
                  {customer.shipping.cityshipping}
                </DataParagraph>
                <DataParagraph>
                  {customer.shipping.countryshipping}
                </DataParagraph>
              </ContentContainer>
            </React.Fragment>
          ) : (
              <React.Fragment>
                <ContentContainer>
                  <HeadingSmall>Rechnungsadresse</HeadingSmall>
                  <DataParagraph>
                    {user.billing.firstName} {user.billing.lastName}
                  </DataParagraph>
                  <DataParagraph>{user.billing.address1}</DataParagraph>
                  <DataParagraph>
                    {user.billing.postcode} {user.billing.city}
                  </DataParagraph>
                  <DataParagraph>{user.billing.country}</DataParagraph>
                  {/* <p>{user.billing.phone}</p>
                <p>{user.billing.email}</p> */}
                </ContentContainer>
                <ContentContainer>
                  <HeadingSmall>Lieferadresse</HeadingSmall>
                  <DataParagraph>
                    {user.shipping.firstName} {user.shipping.lastName}
                  </DataParagraph>
                  <DataParagraph>{user.shipping.address1}</DataParagraph>
                  <DataParagraph>
                    {user.shipping.postcode} {user.shipping.city}
                  </DataParagraph>
                  <DataParagraph>{user.shipping.country}</DataParagraph>
                </ContentContainer>
              </React.Fragment>
            )}
          <Padding>
            <StyledButton
              onClick={() =>
                activeView(
                  parentPage === "SingleBuyerPage"
                    ? "AddProduct"
                    : parentPage === "ImportOrderPage"
                      ? "Import"
                      : "AddProduct"
                )
              }
              scale={"ORDER"}
              title={"Bestellung ändern"}
              color={"#CCB242"}
              fontSize={"20px"}
            />
            <div style={{ height: "5px" }} />
            <StyledButton
              onClick={() => CheckValidOrder()}
              scale={"ORDER"}
              title={"Zahlungspflichtig bestellen"}
              color={"#B2982A"}
              fontSize={"20px"}
              error={errorWeight}
              loading={loadingExtCart}
            />
          </Padding>
        </LoginContainer>
        {!loadingExtCart ? (
          <>
            {" "}
            <ListWrapper>
              <div>
                {/* {selected.map((select, index) => (
							<CheeseList key={index}>
								<Selected key={index} index={index} select={select} />
							</CheeseList>
						))} */}

                {selected && selected.length != 0 && (
                  <>
                    <AccordionComp
                      data={selected}
                      totalCart={content?.extCart.total
                        .toFixed(2)
                        .toString()
                        .replace(".", ",")}
                      parentPage={"OrderOverview"}
                    />
                    <Paragraph>Das Gesamtgewicht beträgt: <strong>{content?.extCart?.totalWeight} kg</strong> </Paragraph>
                  </>
                )}
                {!loadingExtCart && parentPage != "SingleBuyerPage" && selected && selected.length != 0 && <Paragraph>{duration.toString().includes("Bestelldauer") ? <strong>{duration}</strong> : <>Die Bestellung ist noch {duration.toString().includes("Uhr") ? <strong> bis {duration}</strong> : <strong>{duration} Tage</strong>} offen.</>}</Paragraph>}

                {user.hasCoupon && <div style={{ display: "wrap" }}>
                  {couponAmount && couponType && (
                    <Paragraph style={{ marginTop: "50px" }}>
                      Mit diesem Coupon erhälst du <strong>{couponAmount} {couponType} </strong>auf
                  den <strong>NETTO-Preis!</strong>
                    </Paragraph>
                  )}



                  {parentPage !== "ImportOrderPage" && selected && selected.length != 0 &&
                    toggleCoupon &&
                    showCoupon && (
                      <React.Fragment>
                        <RefInput
                          forwardedRef={couponsRef}
                          type={"text"}
                          placeholder={"Gutschein-Code einlösen"}
                          maxLength="40"
                        ></RefInput>
                        <StyledButton
                          onClick={() => CheckCoupon()}
                          scale={"ORDER"}
                          title={"Gutschein einlösen"}
                          color={colors.YellowBrigthButton}
                          fontSize={"20px"}
                          loading={loading2}
                        />
                      </React.Fragment>
                    )}
                </div>}
              </div>
            </ListWrapper>
            {reload && selected && !loadingExtCart && selected.length != 0 && (
              <SelectContainer>
                <SelectWrapper>
                  {parentPage === "SingleBuyerPage" ? (
                    <SingleSelect
                      fontSize="16"
                      checked={showPriceState}
                      onChange={() => {
                        saveShowNamePrice("price");
                      }}
                      caption={"Preis auf Etikett drucken"}
                    />
                  ) : (
                      <>
                        <SingleSelect
                          fontSize="16"
                          checked={showPriceState}
                          onChange={() => {
                            saveShowNamePrice("price");
                          }}
                          caption={"Preis auf Etikett drucken"}
                        />
                        <SingleSelect
                          fontSize="16"
                          checked={showNameState}
                          onChange={() => {
                            saveShowNamePrice("name");
                          }}
                          caption={"Name auf Etikett drucken"}
                        />
                      </>
                    )}
                </SelectWrapper>
              </SelectContainer>
            )}
          </>
        ) : (
            <Loader
              height={200}
              width={100}
              type="ThreeDots"
              color={colors.YellowBrigthButton}
            />
          )}
        {(showCouponAlert || showCouponErrorAlert) && <Alert isVisible={showCouponAlert || showCouponErrorAlert}>
          <ParagraphCenter>{showCouponErrorAlert ? "Gutschein-Code nicht gültig" : "Coupon erfolgreich eingesetzt"}</ParagraphCenter>
          <ImageWrapper>
            <ImageLogo alt={"test"} src={Brand}></ImageLogo>
            <div style={{ height: "20px" }} />
          </ImageWrapper>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <StyledButton
              onClick={() => {
                setShowCouponAlert(false);
                setShowCouponErrorAlert(false);
              }}
              scale={"ORDER"}
              title={"OK"}
              color="#CCB242"
              fontSize={"20px"}
            />
          </div>
        </Alert>}
      </Content>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  /* margin-left: 10vw; */
  width: 100%;
  flex-direction: row;
`;

const ListWrapper = styled.div`
  padding: 20px 0;
  margin-left: 10%;
  @media (max-width: 1160px){
    margin-left: 0;
  }
`;

const Content = styled.div`
  width: 70vw;
  /* height: 80vh; */
  display: flex;
  flex-direction: row;
  /* margin-top: 40px; */
  /* justify-content: space-around; */
  padding: 0 50px;
  background-color: #ffffff;
  @media (max-width: 1160px){
    flex-direction: column;
  }
  @media (max-width: 770px){
    width: 85vw;
    padding: 0 20px;
    align-items: center;
  }
  @media (max-width: 500px){
    width: 95vw;
    padding: 0;
  }
`;

const LoginContainer = styled.div`
  padding: 20px 0;
  width: 241px;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;

  p {
    margin: 0;
  }
`;
const ParagraphCenter = styled.p`
  color: #808080;
  font-size: 16px;
  letter-spacing: 0.4px;
  font-family: "Montserrat";
  font-weight: 300;
  padding: 0;
  text-align: center;
`;
const ImageWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;
const ImageLogo = styled.img`
  width: 312px;
  justify-content: center;
`;
const SelectContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 16vw;
  margin-left: 3vw;
  @media (max-width: 1160px){
    margin: 0;
  }
  @media (max-width: 1250px) {
    width: 30vw;
  }
  @media (max-width: 770px) {
    width: 40vw;
  }
  @media (max-width: 570px) {
    width: 60vw;
  }
  @media (max-width: 370px) {
    margin: 0;
    width: 90vw;
  }
`;
const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 9vh;
  margin-left: 30px;
  @media (max-width: 770px) {
    margin-top: 0;
    margin-left: 0;
  }
`
const Padding = styled.div`
  padding: 25% 0;
  @media (max-width: 770px){
    padding-bottom: 0;
    padding-top: 30px;
  }
`;

const HeadingSmall = styled.h4`
  font-family: "Montserrat";
  font-weight: 300;
  color: #4d4d4d;
  font-size: 16px;
  letter-spacing: 0.4px;
`;

const DataParagraph = styled.p`
  font-family: "Montserrat";
  font-weight: 300;
  color: #808080;
  font-size: 16px;
  letter-spacing: 0.4px;
`;

const CircleWrapper = styled.div`
  position: absolute;
  top: 17vh;
  right: 2vw;
  cursor: pointer;

  @media (max-width: 1300px) {
    top: 25vh;
  }
  @media (max-width: 1270px) {
    display: none;
  }
`;

const Paragraph = styled.p`
  font-size: 14px;
  font-family: "Montserrat", sans-serif;
  font-weight: 200;
`;
export default OrderOverview;
